module.exports = __webpack_public_path__ + "static/media/accounting.8c1a5afc.jpg";